/**
 * Módulo de activación en planta (#41).
 *
 * `POST /api/v1/activations/bulk` exige `analyst`, y esta pantalla es la
 * consola de la línea de empaque: sin ese rol, todo lo que hay para hacer acá
 * termina en 403. La guarda va en la rama entera y no dentro del componente
 * (ver `routes/module.ts`).
 */
import type { ModuleRoutes } from '../module';
import { ActivationDetailPage } from './ActivationDetailPage';
import { ActivationModesPage } from './ActivationModesPage';
import { ActivationPage } from './ActivationPage';

export const moduleRoutes: ModuleRoutes = {
  moduleId: 'activation',
  minimumRole: 'analyst',
  routes: [
    { path: '', element: <ActivationPage /> },
    // `modes` va ANTES que `:activationId`: react-router prefiere el segmento
    // estático, pero dejarlo primero hace que eso no dependa de saberlo.
    { path: 'modes', element: <ActivationModesPage /> },
    { path: ':activationId', element: <ActivationDetailPage /> },
  ],
};
